import { GithubLogo, LinkedinLogo } from "@phosphor-icons/react"

const iconLinkClass =
  "pointer-events-auto inline-flex h-11 w-11 items-center justify-center rounded-full text-foreground/50 transition-colors hover:bg-white/8 hover:text-foreground"

export function RightSidebar() {
  return (
    <aside data-sidebar="right" className="pointer-events-none fixed inset-y-0 right-0 z-40 hidden w-32 flex-col items-center px-3 py-20 md:flex lg:w-52 lg:px-6 lg:py-24">
      <div data-sidebar-spacer className="flex-1" />
      <div data-sidebar-social className="flex justify-center">
        <div className="flex flex-col items-center gap-1">
          <a
            href="https://github.com/buraian"
            target="_blank"
            rel="noopener noreferrer"
            className={iconLinkClass}
            aria-label="GitHub"
          >
            <GithubLogo className="size-5 lg:size-6" weight="fill" />
          </a>
          <a
            href="https://linkedin.com/in/devbrianclark"
            target="_blank"
            rel="noopener noreferrer"
            className={iconLinkClass}
            aria-label="LinkedIn"
          >
            <LinkedinLogo className="size-5 lg:size-6" weight="fill" />
          </a>
        </div>
      </div>

    </aside>
  )
}
